var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"text-center mt-auto"},[_c('p',{staticClass:"mt-3"},[_c('strong',[_vm._v("Side Realms © "+_vm._s(_vm.year))])])])}
var staticRenderFns = []

export { render, staticRenderFns }